import { cva, VariantProps as CvaVariantProps } from 'class-variance-authority';
import styles from './Button.module.css';

export const variants = cva(styles.base, {
    variants: {
        intent: {
            prominent: styles.prominent,
            neutral: styles.neutral,
            negative: styles.negative,
        },
        appearance: {
            solid: styles.solid,
            outline: styles.outline,
            ghost: styles.ghost,
        },
        disabled: {
            false: styles.enabled,
            true: styles.disabled,
        },
    },
    defaultVariants: {
        intent: 'prominent',
        appearance: 'solid',
        disabled: false,
    },
});

export type VariantProps = CvaVariantProps<typeof variants>;
